import classic from './classic'
export default [
  ...classic,
  ['b82800', 'Raspberry'],
  ['e75a11', 'Tiger Orange'],
  ['9c4a00', 'Brown'],
  ['75ffa5', 'Green'],
  ['75ffd1', 'Turquoise'],
]
